import { BoxProps, Flex, Text } from 'uikit'
import { BetPosition, Round } from 'state/types'
import { useTranslation } from 'react-i18next'
import { formatUsd } from '../History/helpers'
import PositionTag from '../PositionTag'
import { LockPriceHistoryRow, PrizePoolHistoryRow, RoundResultBox } from './styles'

interface RoundResultProps extends BoxProps {
  round: Round
}

const RoundResult: React.FC<RoundResultProps> = ({ round, children, ...props }) => {
  const { lockPrice, closePrice, totalAmount } = round
  const betPosition = closePrice > lockPrice ? BetPosition.BULL : BetPosition.BEAR
  // const isPositionUp = betPosition === BetPosition.BULL
  const { t } = useTranslation()
  const priceDifference = closePrice - lockPrice
  return (
    <RoundResultBox
      betPosition={betPosition}
      {...props}
      style={{ width: '100%', padding: '1px', borderRadius: '12px' }}
    >
      <Text color="textRemark" fontSize="14px" bold mb="2px">
        {t('PREDICTION_40')}
      </Text>
      {round.failed ? (
        <Text bold color="textDisabled" mb="8px" fontSize="20px">
          {t('PREDICTION_41')}
        </Text>
      ) : (
        <Flex alignItems="center" justifyContent="space-between" mb="8px">
          <Text color="text" bold fontSize="20px">
            {formatUsd(closePrice)}
          </Text>
          <PositionTag betPosition={betPosition}>{formatUsd(priceDifference)}</PositionTag>
        </Flex>
      )}
      {lockPrice > 0 && <LockPriceHistoryRow lockPrice={lockPrice} mb="8px" />}
      <PrizePoolHistoryRow totalAmount={totalAmount} mb="8px" />
      {children}
    </RoundResultBox>
  )
}

export default RoundResult
